export enum CallAcceptanceStatus {
  Unknown = 'unknown',
  Accepted = 'accepted',
  Rejected = 'rejected',
  Pending = 'pending',
  Scheduled = 'scheduled',
  Scanceled = 'canceled',
  Started = 'started',
  Ongoing = 'ongoing',
  Ended = 'ended',
  Missed = 'missed',
  Declined = 'declined'
}